<div class="container" id="detailsPreviewPrint" style="display: none" [style]="{ width: '100%' }" [scrollable]="true">
  <table width="100%" cellspacing="0" cellpadding="0" align="center">
      <tr>
          <td colspan="5" style="border-bottom: 2px solid var(--primary-color); padding-bottom: 5px">
              <div style="text-align: center; font-size: 12px; font-weight: bold; width: 100%">
                  {{ app?.organizationData?.name }}
              </div>
              <div style="text-align: center; font-size: 12px; font-weight: bold; width: 100%">
                {{ selectedWindow == "balance" ? "Balance Sheet" : selectedWindow == 'pLStatement' ? "Profit & Loss" : 'Cashflow Statement' }}
              </div>
              <div style="text-align: center; font-size: 10px; width: 100%">
                {{ selectedDateFilter?.label }} ( {{ selectedWindow !== 'balance' ? (dateFrom | date:'MM/dd/yyyy') + ' - ' : '' }}{{ dateTo | date:'MM/dd/yyyy' }} )
              </div>
            </td>
      </tr>
      <ng-container *ngFor="let colGroup of columnChunks; let pageIndex = index">
          <tr *ngIf="pageIndex > 0" style="height: 10px"></tr>
          <tr *ngIf="pageIndex > 0">
              <td colspan="5" style="border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px"></td>
          </tr>
          <tr>
              <th style="padding-top: 8px"></th>
          </tr>
          <tr>
              <th style="font-size: 10px; text-align: left">
                  {{ colGroup[0]?.header }}
              </th>
              <ng-container *ngFor="let col of colGroup.slice(1)">
                  <th style="font-size: 10px; text-align: right; padding-bottom: 3px">
                      {{ col.header }}
                      <div *ngIf="col.header" style="border-bottom: 1px solid #888; width: 90%; margin: auto"></div>
                  </th>
              </ng-container>
          </tr>
          <ng-container *ngFor="let report of profitReport">
              <tr>
                  <td>
                      <div style="font-size: 9px; padding-left: 3px; font-weight: bold; white-space: nowrap">
                          {{ report?.data?.financialAccountName }}
                      </div>
                  </td>
                  <ng-container *ngFor="let col of colGroup.slice(1)">
                      <td style="text-align: right">
                          <div style="padding-bottom: 2px; font-size: 8px">
                              {{ report?.data?.[col.field] ? (col.fieldType == "currency" || col.fieldType == "balanceTotal" ? (report?.data?.[col.field] | number: "1.2-2" | currencySymbol) : col.fieldType == "percentage" ? (report?.data?.[col.field] | number: "1.2-2") + "%" : (report?.data?.[col.field] | number: "1.2-2")) : col.fieldType == "currency" || col.fieldType == "balanceTotal" ? (0 | number: "1.2-2" | currencySymbol) : (0 | number: "1.2-2") + "%" }}
                          </div>
                      </td>
                  </ng-container>
              </tr>
              <tr *ngIf="!report?.children?.length">
                <td></td>
                <ng-container *ngFor="let col of colGroup.slice(1)">
                    <td>
                        <div style="border-top: 3px double #888; width: 95%; margin: auto; padding-top: 3px"></div>
                    </td>
                </ng-container>
            </tr>
              <ng-container *ngTemplateOutlet="recursiveRows; context: { rows: report.children, colGroup: colGroup, level: 1 }"></ng-container>
          </ng-container>
      </ng-container>
  </table>
</div>
<!-- recursiveRows -->
<ng-template #recursiveRows let-rows="rows" let-colGroup="colGroup" let-level="level">
  <ng-container *ngFor="let child of rows; let last = last">
      <tr>
          <td>
              <div [style.font-size]="'8px'" [style.padding-left]="level * 3 + 2 + 'px'" [style.font-weight]="level === 1 ? 'bold' : level === 2 ? 'bolder' : 'lighter'" style="white-space: nowrap">
                  {{ child?.data?.financialAccountName }} {{ child?.children?.length ? '(' + child?.children?.length + ' items)' : '' }}
              </div>
          </td>
          <ng-container *ngFor="let col of colGroup.slice(1)">
              <td [ngStyle]="{ 'text-align': 'right', 'font-size': '8px' }">
                  {{ child?.data?.[col.field] ? (col.fieldType == "currency" || col.fieldType == "balanceTotal" ? (child?.data?.[col.field] | number: "1.2-2" | currencySymbol) : col.fieldType == "percentage" ? (child?.data?.[col.field] | number: "1.2-2") + "%" : (child?.data?.[col.field] | number: "1.2-2")) : col.fieldType == "currency" || col.fieldType == "balanceTotal" ? (0 | number: "1.2-2" | currencySymbol) : (0 | number: "1.2-2") + "%" }}
              </td>
          </ng-container>
      </tr>
      <tr *ngIf="level > 2 && !child?.children?.length && last">
          <td></td>
          <ng-container *ngFor="let col of colGroup.slice(1)">
              <td>
                <div style="border-top: 1px solid #888; width: 90%;  width: 95%; margin: auto; padding-top: 3px"></div>
              </td>
          </ng-container>
      </tr>
      <tr *ngIf="level == 1 && !child?.children?.length && last">
          <td></td>
          <ng-container *ngFor="let col of colGroup.slice(1)">
              <td>
                  <div *ngIf="child?.data?.[col.field]" style="border-top: 4px double #888; width: 95%; margin: auto; padding-top: 3px"></div>
              </td>
          </ng-container>
      </tr>
      <ng-container *ngIf="child?.children?.length">
          <ng-container *ngTemplateOutlet="recursiveRows; context: { rows: child.children, colGroup: colGroup, level: level + 1 }"></ng-container>
      </ng-container>
  </ng-container>
</ng-template>
